import * as XLSX from 'xlsx';

export type SpreadsheetCell = string | number | null | undefined;

/// Uma aba: a primeira linha é o cabeçalho.
export interface SpreadsheetSheet {
    name: string;
    rows: SpreadsheetCell[][];
}

/// O Excel recusa aba com mais de 31 caracteres ou com : \ / ? * [ ].
const sheetName = (name: string) => name.replace(/[:\\/?*[\]]/g, ' ').slice(0, 31) || 'Planilha';

export const buildWorkbook = (sheets: SpreadsheetSheet[]): XLSX.WorkBook => {
    const workbook = XLSX.utils.book_new();

    sheets.forEach((sheet) => {
        const worksheet = XLSX.utils.aoa_to_sheet(sheet.rows.map((row) => row.map((cell) => cell ?? '')));

        // Largura pelo conteúdo: coluna estreita esconderia o nome do lead e o e-mail.
        worksheet['!cols'] = (sheet.rows[0] ?? []).map((_, column) => ({
            wch: Math.min(60, Math.max(10, ...sheet.rows.map((row) => String(row[column] ?? '').length + 2))),
        }));

        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName(sheet.name));
    });

    return workbook;
};

/// Gera e baixa o .xlsx no navegador: os dados já estão na tela e não precisam voltar ao servidor.
export const downloadSpreadsheet = (fileName: string, sheets: SpreadsheetSheet[]) =>
    XLSX.writeFile(buildWorkbook(sheets), fileName.endsWith('.xlsx') ? fileName : `${fileName}.xlsx`);

/// "leads-2026-09-28": o dia no nome evita o "leads (3).xlsx" na pasta.
export const datedFileName = (prefix: string, now: Date = new Date()) => {
    const pad = (n: number) => String(n).padStart(2, '0');

    return `${prefix}-${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}.xlsx`;
};
